"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExpectedResolutionHeight = getExpectedResolutionHeight;
exports.getNumMeetingParticipants = getNumMeetingParticipants;
exports.sendNetworkHealthLogToDatadog = sendNetworkHealthLogToDatadog;
var _logger = require("@studio/logger");
/**
 * Expected resolution height is derived from meeting's video uplink policy
 * It's based on:
 *   - current no. of videos on in the meeting
 *   - targetHeightArray
 *   - any uplink priority defined
 * https://github.com/shoflo-internal/studio/blob/main/libs/chime/src/bandwidthPolicies/StudioVideoUplinkBandwidthPolicy.js
 */
function getExpectedResolutionHeight(meetingSession) {
  var _meetingSession$confi;
  var uplinkPolicy = meetingSession === null || meetingSession === void 0 || (_meetingSession$confi = meetingSession.configuration) === null || _meetingSession$confi === void 0 ? void 0 : _meetingSession$confi.videoUplinkBandwidthPolicy;
  if (uplinkPolicy && 'getExpectedTargetHeight' in uplinkPolicy) {
    return uplinkPolicy.getExpectedTargetHeight();
  }
}
function getNumMeetingParticipants(meetingSession) {
  var _meetingSession$confi2;
  var uplinkPolicy = meetingSession === null || meetingSession === void 0 || (_meetingSession$confi2 = meetingSession.configuration) === null || _meetingSession$confi2 === void 0 ? void 0 : _meetingSession$confi2.videoUplinkBandwidthPolicy;
  if (uplinkPolicy && 'getNumParticipants' in uplinkPolicy) {
    return uplinkPolicy.getNumParticipants();
  }
}

/**
 * Send network health metrics to Datadog for troubleshooting
 * Send only when network quality is available i.e. video is turned on
 * and send metrics from which network quality is derived i.e. videoMOS, frame height, and expected frame height
 */
function sendNetworkHealthLogToDatadog(networkHealthPayload, meetingSession, currentAttendeeId) {
  if (networkHealthPayload.networkQuality && networkHealthPayload.networkQuality !== 'NA') {
    var videoMOS = networkHealthPayload.videoMOS,
      videoFrameHeight = networkHealthPayload.videoFrameHeight,
      networkQuality = networkHealthPayload.networkQuality;
    var expectedResolutionHeight = getExpectedResolutionHeight(meetingSession);
    var networkHealthMetrics = {
      networkQuality: networkQuality,
      videoMOS: videoMOS,
      videoFrameHeight: videoFrameHeight,
      expectedResolutionHeight: expectedResolutionHeight
    };
    (0, _logger.sendToDatadog)('networkhealth-metrics', {
      networkHealthMetrics: networkHealthMetrics,
      'attendee-id': currentAttendeeId
    }, "Network health metrics for user ".concat(currentAttendeeId));
  }
}